export default "__VITE_ASSET__C95Uw9Qd__"